import {
  ModelVersionENV,
  ModelVersionENVValues,
  ModelVersionESS,
  ModelVersionESSValues,
} from '@/domain/project/entities/project.entity';
import { ProjectTour } from '@/domain/project-tour/entities/project-tour.entity';
import { validateValueInType } from '@/domain/utils/validate-value-in-type';

import { ProjectTourDto } from './project-tour.dto.schema';

type ProjectTourDtoOmitId = Omit<ProjectTourDto, 'id' | 'models'>;

export class ProjectTourMapper {
  static dtoToEntity(dto: ProjectTourDto): ProjectTour {
    return {
      id: dto.id,
      organisationId: dto.organisationId,
      type: 'tour',
      name: dto.name,
      image: dto.image || '',
      startDate: dto.startDate,
      endDate: dto.endDate,
      models: {
        ess: validateValueInType<ModelVersionESS>(
          dto.models.ess,
          ModelVersionESSValues,
        ),
        env: validateValueInType<ModelVersionENV>(
          dto.models.env,
          ModelVersionENVValues,
        ),
      },
    };
  }

  static entityToDto(project: ProjectTour): ProjectTourDtoOmitId {
    return {
      organisationId: project.organisationId || 0,
      image: project.image,
      name: project.name,
      startDate: project.startDate
        ? new Date(project.startDate).toISOString()
        : null,
      endDate: project.endDate ? new Date(project.endDate).toISOString() : null,
    };
  }
}
